import { BaseControl } from "../base-control";

class SearchSelectControlCtrl extends BaseControl {
  items = [];
  templateColumns = [];
  page = 0;
  pageCount = 0;
  pageCounter = '';
  modal = null;
  loading = "Fetching Records";
  loadingRecords = true;
  term = "";
  totalQueryResults = 0;
  cdd = null;
  cddOk = true;
  cddWhere = [];
  hasValue = false;
  displayValue = null;
  selectedItemIndex = null;

  get pageSize() {
    return parseInt(this.token.options?.filter?.pageSize || "10");
  }
  constructor(BaseControlService, $scope, RecordService, $uibModal, $element) {
    'ngInject';
    super(BaseControlService, $scope);
    this.rs = RecordService;
    this.$uibModal = $uibModal;
    this.$element = $element;
  }

  async initializeControlData(){
    await super.initializeControlData();
    this.defaultFields = this.token.control.foreignKey.defaultFields;
    this.fids = this.token.options?.selectFieldIds || this.defaultFields.slice(0, 5).map(f => f.id);
    this.fkFid = this.token.control.foreignKey.keyFieldId;
    if (this.model.value) await this.loadDisplayValue();
    this.templateColumns = this.buildColumns();
    this.isPrint || this.cddInit() || this.subscribePrefetch();
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
    this.updateRelatedSelect();
  }

  updateFlags() {
    this.hasValue = ((this.model.value || '').toString().length) > 0;
    this.placeholder = this.getPlaceholder();
  }

  updateRelatedSelect() {
    const relValue = this.rs._updatedDisplayValues?.[this.referenceFieldHash];
    if(relValue === undefined) return;
    // NOTE: this handles multiple instances of the same field:
    this.displayValue = relValue;
  }

  subscribePrefetch() { // query initial records once form is idle    
    this.es.subscribeEvent(
      this.es.actions.RENDER_COMPLETE, () => { if (this.enabled) this.newTerm(); },
      'RENDER_COMPLETE_' + this.token.id
    );
  }

  // For embedded tokens (_temp), resolve parent report token-id and fieldId from DOM. Returns { tokenId, fieldId } or null.
  getEmbeddedTokenParams() {
    if (!this.token._temp || !this.$element) return null;
    const $reportContainer = $(this.$element).closest('report-control').parent();
    if (!$reportContainer.length) return null;
    const tokenId = $reportContainer.attr('token-id');
    const fieldId = this.token.fieldId;
    return tokenId != null && fieldId != null ? { tokenId, fieldId } : null;
  }

  async loadDisplayValue() {
    const templateId = this.ts.templateId;
    let tokenId = this.token.id;
    let fieldId = undefined;
    const embedded = this.getEmbeddedTokenParams();
    if (embedded) {
      tokenId = embedded.tokenId;
      fieldId = embedded.fieldId;
    } else if (this.token._temp) {
      this.closeModal();
      return;
    }
    const foreignKeyValue = this.stdModel();
    const queryResponse = await this.rs.queryRecords({ type: 'searchSelectDisplay', templateId, tokenId, fieldId, foreignKeyValue });
    this.updateModel(queryResponse?.data?.results[0]?.records?.[0]);
  }

  onKeyDown(event) {
    switch (event.key) {
      case 'Enter':
        this.openModal(event);
        break;
    }
  }

  focusInput(event) {
    // do not trigger modal unless previous/source element was a fe-control child
    if (!$(event.relatedTarget).closest('fe-control').length) return;
    else this.openModal(event);
  }

  clearSearch() {
    if (this.loadingRecords) return;
    this.term = "";
    this.newTerm();
  }

  updateModel(foreignRecord = {}) {
    this.foreignRecord = foreignRecord;
    const displayVal = foreignRecord?.[this.fids[0]]?.display || '';
    this.rs._updatedDisplayValues = { ...(this.rs._updatedDisplayValues || {}), [this.referenceFieldHash]: displayVal };
    this.es.dispatchEvent(
      this.es.actions.FOREIGN_KEY_CHANGED,
      { value: this.stdModel(foreignRecord), token: this.token, foreignRecord }
    );
    this.displayValue = foreignRecord?.[this.fids[0]]?.display;
    this.closeModal();
  }

  buildColumns() {
    return this.fids.map(f => {
      const field = this.defaultFields.find(df => df.id == f);
      if (!field) return null;
      return {
        'key': field.id,
        'header': field.label,
        'sortable': false,
        'format': (value) => {
          if (typeof value.display === 'string') {
            return value.display;
          } else if (typeof value.display === 'object' && !!value.display?.filename) {
            return `<a target="_blank" href="${value.display?.url}">${value.display?.filename}</a>`;
          }
          return value.display;
        }
      };
    }).filter(f => f !== null);
  }

  modalKeyDown(event) {
    this.selectedItemIndex = this.selectedItemIndex || 0;

    switch (event.key) {
      case 'ArrowDown':
        this.selectedItemIndex++;
        break;
      case 'ArrowUp':
        this.selectedItemIndex--;
        break;
      case 'Enter':
        if (this.items[this.selectedItemIndex - 1]) {
          this.updateModel(this.items[this.selectedItemIndex - 1], this.selectedItemIndex - 1);
        }
        return;
      case 'PageDown':
        return this.moveToPage(1);
      case 'PageUp':
        return this.moveToPage(-1);
      case 'Escape':
        return this.closeModal();
      case 'Tab':
        return this.closeModal();
      default:
        this.selectedItemIndex = null;
        return;
    }

    if (this.selectedItemIndex > this.items.length) this.selectedItemIndex = 1;
    if (this.selectedItemIndex < 1) this.selectedItemIndex = this.items.length;
  }

  openModal() {
    this.page = 1;

    const modalSettings = {
      backdrop: 'true',
      windowClass: 'token-modal',
      templateUrl: 'fe-control/modals/search-select/search-select.component.html',
      scope: this.$scope,
      size: 'lg'
    };
    this.modal = this.dom.openModal(this.$uibModal, modalSettings, { triggerElement: this.$element });
    this.iosHandleZoomFocus('#search-select-term');
    this.filterItems();
    
    this.modal.result.then(
      closed => this.closeModal(),
      canceled => this.closeModal()
    );
  }
  
  iosHandleZoomFocus(inputSelector){
    // iOS JS input focus must be a direct result of a user-action
    const $iosBody = $('body.ios-device');
    if (!$iosBody.length) return null;
    
    const $tmpEl = $('<textarea style="width: 100%; position: fixed; font-size: 16px">')
    $iosBody.prepend($tmpEl);
    $tmpEl.focus(); // zoom out to full screen width
    
    this.$timeout(_ => this.iosTransferFocus($tmpEl, $(inputSelector)))
  }
  
  iosTransferFocus($prevEl, $targetEl) {
    $targetEl.focus(); // transfer focus
    $prevEl.remove();
    
    // 16px <input> fontsize was used (CSS) to block iOS zoom-on-focus;
    // now we can restore original font-size;
    $targetEl.addClass('unset-font-size');
  }
  
  closeModal() {
    if (!this.modal) return;
    this.modal?.dismiss();
    this.modal = null;
    // $('body').blur();
    this.$timeout(() => $(`#${this.token.id}-control`).focus());
  }

  async newTerm() {
    this.page = 1;
    this.totalQueryResults = 0;
    this.items = [];
    await this.filterItems();
  }

  async moveToPage(dir) {
    if (this.loadingRecords) return;

    const newPage = this.page + dir;
    if (newPage < 1 || newPage > this.pageCount) return;
    this.page += dir;

    await this.filterItems();
  }

  async filterItems() {
    this.loadingRecords = true;
    this.selectedItemIndex = null;
    this.loading = this.term ? `Finding '${this.term}'` : "Fetching Records";

    const filterValue = this.getFixedFilterValue();
    const templateId = this.ts.templateId;

    let tokenId = this.token.id;
    let fieldId = undefined;
    const embedded = this.getEmbeddedTokenParams();
    if (embedded) {
      tokenId = embedded.tokenId;
      fieldId = embedded.fieldId;
    } else if (this.token._temp) {
      this.closeModal();
      return;
    }

    const queryResponse = await this.rs.queryRecords({
      type: 'searchSelectSearch', templateId, tokenId, fieldId, term: this.term || undefined,
      pageSize: this.pageSize, page: this.page, cddWhere: this.cddWhere?.length > 0 ? this.cddWhere : undefined,
      filterValue
    });

    const { records, totalQueryResults } = queryResponse.data.results[0];
    this.loading = "";
    this.items = records;
    this.totalQueryResults = totalQueryResults;
    this.pageCount = Math.ceil(this.totalQueryResults / this.pageSize);

    const initItem = ((this.page - 1) * this.pageSize) + 1;
    const endItem = Math.min(initItem + this.pageSize - 1, this.totalQueryResults);
    this.pageCounter = `${initItem} to ${endItem} of ${this.totalQueryResults}`;
    this.loadingRecords = false;
    this.focusSearchInput();
  }

  getFixedFilterValue() {
    const refId = this.token.options?.filter?.referenceId;
    const fieldValueId = this.token.options?.filter?.valueFid;
    if (!refId || !fieldValueId) return null;
    
    const fieldValue = ((this.rs.records[refId] || {})[fieldValueId] || {}).value;
    return fieldValue || null;
  }

  focusSearchInput() {
    $('#search-select-term').focus();
  }

  clear() {
    this.updateModel();
  }

  getPlaceholder() {
    if (this.stdModel()) return '';

    if (this.cddOk) return `Search ${this.label}`;
      
    const relatedToken = this.ts.tokens.find(t => t.id === this.cdd.relatedTokenId);
    const relatedLabel = relatedToken?.fieldSchema.label;
    return `Choose ${relatedLabel} first`;
  }

  cddInit() {
    if (!Object.values(this.token.options?.cdd || {}).filter(v => v).length) {
      return false;
    }

    this.cdd = this.token.options.cdd;
    this.cddOk = false;

    this.es.subscribeEvent(
      this.es.actions.FOREIGN_KEY_CHANGED, ({ value, token }) => this.updateCdd(value, token),
      'FOREIGN_KEY_CHANGED_' + this.token.id
    );

    return this.validateCdd();
  }

  updateCdd(value, fToken) {
    if (this.cdd.relatedTokenId !== fToken.id) return;

    this.cddOk = !!value;

    this.cddWhere = this.cddOk
      ? [{ [this.cdd.cddMatchFid]: { "=": decodeURIComponent(value.toString()) }, }]
      : [];

    this.cddOk ? this.newTerm() : this.clear();
  }

  validateCdd() { // not explicitly checking cddMatchFid against foreign table schema
    const relatedToken = this.ts.tokens.find(t => t.id === this.cdd.relatedTokenId);

    if (!relatedToken) throw new Error('CDD Match Token missing!');
    return true;
  }

}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/search-select-control/search-select-control.component.html",
  controller: SearchSelectControlCtrl
};

